import { createAction } from 'Lib/reduxUtils';

import {
  LOAD_INSENDIO_CAMPAIGNS,
  LOAD_INSENDIO_CAMPAIGNS_SUCCESS,
  SET_INSENDIO_CAMPAIGN_VIEWED,
} from './constants';

export const loadInsendioCampaigns = createAction(LOAD_INSENDIO_CAMPAIGNS);

export const loadInsendioCampaignsSuccess = createAction(
  LOAD_INSENDIO_CAMPAIGNS_SUCCESS,
  (payload: any) => payload
);

export const setInsendioCampaignViewed = createAction(
  SET_INSENDIO_CAMPAIGN_VIEWED,
  (campaignId: number, campaignType: string) => ({ campaignId, campaignType })
);
